import React, { useState } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { BuildingIcon, GaugeIcon, LayersIcon, LogOutIcon, MenuIcon, ReceiptIcon, ServerIcon, UsersIcon, XIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { WatchtowerMark } from './WatchtowerMark';
import { workerRegions } from '../data/adminPlatform';
const navItems = [{
  to: '/admin',
  label: 'Overview',
  icon: GaugeIcon,
  end: true
}, {
  to: '/admin/customers',
  label: 'Customers',
  icon: BuildingIcon,
  end: false
}, {
  to: '/admin/fleet',
  label: 'Check fleet',
  icon: LayersIcon,
  end: false
}, {
  to: '/admin/revenue',
  label: 'Revenue',
  icon: ReceiptIcon,
  end: false
}, {
  to: '/admin/system',
  label: 'System health',
  icon: ServerIcon,
  end: false
}, {
  to: '/admin/staff',
  label: 'Staff & audit',
  icon: UsersIcon,
  end: false
}];
function SidebarContent({
  onNavigate
}: {
  onNavigate?: () => void;
}) {
  const {
    session,
    signOut
  } = useAuth();
  const navigate = useNavigate();
  const degraded = workerRegions.filter(r => r.state !== 'ok').length;
  return <div className="flex h-full flex-col gap-5 p-4" data-id="element-73" data-mp="3s6eit6929x0c">
      <Link to="/admin" className="flex items-center gap-2 rounded-control px-2 py-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-bright" data-id="element-74" data-mp="3s3sav5i9dfhl">
        <WatchtowerMark className="h-8 w-8 shrink-0 text-white" data-id="element-75" data-mp="jpjqgkpw3v0i" />
        <span className="min-w-0" data-id="element-76" data-mp="jrwg7k1w39o4">
          <span className="block text-[15px] font-semibold leading-none tracking-tight text-white" data-id="element-77" data-mp="eqywv45589l1">
            Watchtower
          </span>
          <span className="mt-1 block font-mono text-[10px] uppercase tracking-[0.16em] text-warn-bright" data-id="element-78" data-mp="sp6p4yr8impv">
            staff console
          </span>
        </span>
      </Link>

      <nav aria-label="Staff console" className="flex flex-col gap-0.5" data-id="element-79" data-mp="2uh1qoljs1aud">
        {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.end} onClick={onNavigate} className={({
        isActive
      }) => `flex items-center gap-2.5 rounded-control px-2.5 py-2 text-[13px] font-medium transition-colors duration-150 ease-snap ${isActive ? 'bg-shell-raised text-white' : 'text-white/60 hover:bg-shell-raised/60 hover:text-white'}`} data-id="element-80" data-mp="2pjtd6y9kpuzg">
            <item.icon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-81" data-mp="1cdohxjy4oz4o" />
            <span className="flex-1" data-id="element-82" data-mp="1hd121wxm7s3k">{item.label}</span>
            {item.label === 'System health' && degraded > 0 && <span className="h-1.5 w-1.5 rounded-full bg-warn-bright" data-id="element-83" data-mp="1m5lvgxcm036k" />}
          </NavLink>)}
      </nav>

      <div className="mt-auto space-y-3" data-id="element-84" data-mp="1r5gmr20aqus5">
        <div className="rounded-card border border-shell-line px-3 py-2.5" data-id="element-85" data-mp="1v5haxed76kce">
          <p className="font-mono text-[10px] uppercase tracking-[0.12em] text-white/40" data-id="element-86" data-mp="204226oah1top">
            Signed in as
          </p>
          <p className="mt-1.5 truncate text-[13px] font-medium text-white" data-id="element-87" data-mp="3kmcvh9pol044">
            {session?.name}
          </p>
          <p className="truncate font-mono text-[11px] text-white/50" data-id="element-88" data-mp="3fm8elikv23dd">
            {session?.email}
          </p>
        </div>
        <button type="button" onClick={() => {
        signOut();
        navigate('/login');
      }} className="flex w-full items-center gap-2.5 rounded-control px-2.5 py-2 text-[13px] font-medium text-white/60 transition-colors duration-150 ease-snap hover:bg-shell-raised/60 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-bright" data-id="element-89" data-mp="3bnirgya0t7gj">
          <LogOutIcon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="3pk4ne3qbsm8b" />
          Sign out
        </button>
      </div>
    </div>;
}
export function AdminShell() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return <div className="flex min-h-full w-full bg-canvas" data-id="element-91" data-mp="m2w91tut44ic">
      <aside className="sticky top-0 hidden h-screen w-[236px] shrink-0 bg-shell lg:block" data-id="element-92" data-mp="5ogbzer6wnon">
        <SidebarContent data-id="element-93" data-mp="ansz80lz3wrr" />
      </aside>

      {mobileOpen && <div className="fixed inset-0 z-40 lg:hidden" data-id="element-94" data-mp="alyaeb7kzkie">
          <div className="absolute inset-0 bg-ink/50" onClick={() => setMobileOpen(false)} aria-hidden="true" data-id="element-95" data-mp="3sufk7atoohtf" />
          <div className="absolute left-0 top-0 h-full w-[248px] bg-shell shadow-pop" data-id="element-96" data-mp="1p7go5gi4hqz">
            <SidebarContent onNavigate={() => setMobileOpen(false)} data-id="element-97" data-mp="pf1ryil69y94" />
          </div>
        </div>}

      <div className="flex min-w-0 flex-1 flex-col" data-id="element-98" data-mp="tgdc48la1r9x">
        <div className="border-b border-warn-border bg-warn-soft px-4 py-2 sm:px-6 lg:px-8" data-id="element-99" data-mp="fm2q3z0o0b7k">
          <p className="mx-auto w-full max-w-[1120px] font-mono text-[11px] text-warn-ink" data-id="element-100" data-mp="kl71mwb2al12">
            Staff console · you are looking at every customer&apos;s data. Every
            action here is written to the audit log.
          </p>
        </div>

        <div className="sticky top-0 z-20 flex h-14 items-center gap-3 border-b border-line bg-surface px-4 lg:hidden" data-id="element-101" data-mp="1d4cjrakjoib4">
          <button type="button" onClick={() => setMobileOpen(open => !open)} aria-label={mobileOpen ? 'Close menu' : 'Open menu'} className="inline-flex h-9 w-9 items-center justify-center rounded-control border border-line-strong text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand" data-id="element-102" data-mp="1ig9oddmt7gda">
            {mobileOpen ? <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="zigko94d32eu" /> : <MenuIcon className="h-4 w-4" aria-hidden="true" data-id="element-104" data-mp="1dhoml9rwsomq" />}
          </button>
          <span className="flex items-center gap-2 text-sm font-semibold text-ink" data-id="element-105" data-mp="18hamcdwjuiz9">
            <WatchtowerMark className="h-6 w-6 text-brand" data-id="element-106" data-mp="2oval3ljns2kx" />
            Staff console
          </span>
        </div>

        <main className="flex-1 px-4 py-6 sm:px-6 lg:px-8 lg:py-8" data-id="element-107" data-mp="2jvnxqja495ye">
          <div className="mx-auto w-full max-w-[1120px]" data-id="element-108" data-mp="2rxouni5uyfxj">
            <Outlet data-id="element-109" data-mp="2rx5d42k4dtk1" />
          </div>
        </main>
      </div>
    </div>;
}